import axios from "axios";
axios.defaults.baseURL = "/wallet-manage/public/v2";
// 允许携带cookie
axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;
axios.interceptors.response.use(res => {
  return res.data;
});
export default axios;
